import { IPerson } from './GroupAccessOwners/PersonVm';
import { GroupAccessType } from './IHierarchyGroupAccess';

export default interface IGroupAccessOwner extends IPerson {
	hasGroupAccess: true;
	ownerType: GroupAccessOwnerType;
	profile: {
		id: string;
		name: string;
	};
	owns: {
		[hierarchyId: string]: IHierarchyNodeOwnership;
	};
}

export interface IHierarchyNodeOwnership {
	hierarchyName: string;
	ownershipAssigned: GroupAccessType;
	nodesOwned: INodeOwned[];
}

export interface INodeOwned {
	nodeId: string;
	nodeName: string;
}

export enum GroupAccessOwnerType {
	Employee = 0,
	Collaborator = 1,
}
